var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box, styled, Typography } from 'fbm-ui';
export var ReportHeader = styled(Box)({
    height: '595px',
    background: 'url(//webcdn.fbmms.cn/assets/cJym/xhSsGU9JnduulyEKhfy4c) no-repeat',
    backgroundSize: 'cover',
});
export var ReportBadge = styled(Box)({
    position: 'absolute',
    right: 0,
    height: 189,
    width: 189,
    background: 'url(//webcdn.fbmms.cn/assets/2kl2/JKujuvm1grXCLkAfr3jAQ) no-repeat center center',
    backgroundSize: 'cover',
    zIndex: 1,
});
var LabelImage = {
    low: '//webcdn.fbmms.cn/assets/ieud/S3Zpk0MrG7xS7GNhhPR91',
    middle: '//webcdn.fbmms.cn/assets/QSes/sdMFEHcqx5fYijnEU2d-q',
    high: '//webcdn.fbmms.cn/assets/sXb7/jADl-WOO_6B27l56HKlBM',
    calculation: '//webcdn.fbmms.cn/assets/9bjO/UaJ2R4JousNJezEJdY00s',
};
export var ReportLabel = styled(Box)(function (_a) {
    var _b = _a.level, level = _b === void 0 ? 'low' : _b;
    return ({
        position: 'absolute',
        right: 44,
        top: 98,
        height: 265,
        width: 353,
        background: "url(".concat(LabelImage[level], ") no-repeat center center"),
        backgroundSize: 'cover',
    });
});
export var ReportAvatar = styled(Box)(function (_a) {
    var _b = _a.avatar, avatar = _b === void 0 ? '' : _b;
    return ({
        width: 137,
        height: 192,
        background: "url(".concat(avatar ? avatar : '//webcdn.fbmms.cn/assets/g1_W/Mv__5ai_DWtmh8tO6I5P_', ") no-repeat center center"),
        backgroundSize: 'cover',
        borderRadius: 8,
    });
});
export var DinTypography = styled(Typography)({
    fontFamily: 'MiSans TC',
    fontWeight: 500,
});
var ReportTagStyles = [
    {
        color: '#009908',
        background: 'linear-gradient( 180deg, #FFFFFF 0%, #BFFFDF 100%)',
    },
    {
        color: '#FE9D0D;',
        background: 'linear-gradient( 180deg, #FFFFFF 0%, #FFE2B6 100%)',
    },
    {
        color: '#629CFF',
        background: 'linear-gradient( 180deg, #FFFFFF 0%, #BFEBFF 100%)',
    },
];
function hashString(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = hash & hash; // Convert to 32bit integer
    }
    return Math.abs(hash);
}
export var ReportTag = styled(DinTypography)(function (_a) {
    var children = _a.children;
    var hash = children ? Math.abs(hashString(children.toString())) % 3 : 0;
    return __assign(__assign({ flex: '0 1 auto', padding: '2px 8px', fontSize: '12px', lineHeight: '16px', borderRadius: '177px 177px 177px 177px', border: '1px solid #FFFFFF' }, ReportTagStyles[hash]), { mb: 8 });
});
export var ReportEvaluate = styled(Box)({
    // margin: 24,
    mt: 24,
    background: '#FFFBE8',
    boxShadow: ' 0px 2px 6px 0px rgba(91,108,95,0.15)',
    padding: '8px 24px',
    borderRadius: 12,
    '&:before': {
        content: '"综合评价"',
        width: 64,
        display: 'block',
        borderBottom: '5px solid rgba(255, 179, 0, 1)',
    },
});
export var Podium = styled(Box)({
    position: 'relative',
    width: 541,
    height: 342,
    background: "url(//webcdn.fbmms.cn/assets/rure/4ZUY5jv9lZpqhkmRqGUgO) no-repeat center center",
    backgroundSize: 'cover',
    color: '#119E45',
});
export var Video = styled('video')(function (_a) {
    var theme = _a.theme;
    return ({
        width: 166,
        height: 296,
        borderRadius: 8,
        boxShadow: theme.shadows[6],
    });
});
export var ExportButton = styled('a')({
    width: 96,
    height: 40,
    background: 'rgba(0,0,0,0.2)',
    borderRadius: 20,
    border: '1px solid rgba(255,255,255,0.0418)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    fontSize: 16,
    color: '#FFFFFF',
    position: 'absolute',
    top: 'calc(50% - 20px) ',
    left: 'calc(50% - 48px)',
});
export var BeatProgressBar = styled(Box)({
    width: 169,
    height: 16,
    backgroundColor: 'rgba(255, 213, 0, 0.15)',
    borderRadius: 10,
    overflow: 'hidden',
    border: ' 2px solid #FFFFFF',
    '& .progress-bar-fill': {
        height: '100%',
        background: 'linear-gradient( 90deg, #FFD500 0%, #65FFD4 100%), linear-gradient( 180deg, rgba(255,255,255,0.55) 31%, rgba(255,255,255,0) 98%)',
        borderRadius: 10,
        transition: 'width 0.5s ease-in-out',
    },
});
